module.exports = __webpack_public_path__ + "assets/3f651701743474a4144aa19e70f4740f.png";